import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { TenantConfigService } from '../services/tenant-config/tenant-config.service';

/**
 * Gates the cooperation-partner routes behind the tenant config flag `showCooperationPartner`.
 * The menu already hides the entry for tenants without the config, but the route would otherwise
 * stay reachable via direct URL. Guarding the parent route also covers the `:id` detail child,
 * since that child relies on the parent's canActivate.
 */
@Injectable({ providedIn: 'root' })
export class CooperationPartnerConfigGuard implements CanActivate {
  constructor(
    private _tenantConfigService: TenantConfigService,
    private _router: Router
  ) {}

  public async canActivate(): Promise<boolean> {
    const isEnabled = await this._tenantConfigService.showCooperationPartner();
    if (!isEnabled) {
      await this._router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }
}
